export enum EBtnSizeType {
    XS,
    SM,
    MD,
    LG,
    XL,
    XXL
}